import React, { useState } from "react";
import "../../assets/styles/table.css";
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import { IInquiry } from "../../types";
import { inquiryColumns, inquiriesTableData } from "../../constants/constants";
import { useGetInquiryListQuery } from "../../store/api/inquiryApi";
import Pagination from "rc-pagination";

const TableInquiry: React.FC<{
  onView?: (row: IInquiry) => void;
  pageNumber: number;
  setTotalCount: (count: number) => void;
  searchValue?: string;
}> = ({ onView, pageNumber, setTotalCount, searchValue = "" }) => {
  const { data: inquiryData, isLoading: inquiryLoading } =
    useGetInquiryListQuery({ page: pageNumber, search: searchValue });
  React.useEffect(() => {
    setTotalCount(inquiryData?.data?.inquiryCount || 0);
  }, [inquiryData, setTotalCount]);
  // Filter logic

  return (
    <div className="tableWrapper">
      <table className="table">
        <thead>
          <tr>
            {inquiryColumns.map((col) => (
              <th key={col.key} data-column={col.key}>
                {col.label}
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
      </table>
      <div className="tableBodyWrapper">
        <table className="table">
          <tbody>
            {inquiryLoading ? (
              <tr>
                <td colSpan={inquiryColumns.length + 1}>Loading...</td>
              </tr>
            ) : (
              inquiryData?.data?.inquiryList.map((row: IInquiry) => (
                <tr key={row.id}>
                  {inquiryColumns.map((col) => (
                    <td key={col.key} data-column={col.key}>
                      {row[col.key as keyof IInquiry]}
                    </td>
                  ))}
                  <td className="actionCell">
                    <button
                      className="actionButton"
                      onClick={() => onView?.(row)}
                      title="View"
                    >
                      <FiEye />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableInquiry;
